import React from "react";
import { Edit } from "react-admin";
import { EditActions } from "../../common/form/FormActions";
import { TenantRegistrationForm } from "./TenantRegistrationForm";
import { useNotification } from "../../../common/hooks/useNotification";

interface ITenantRegistrationCreateProps {}

export const TenantRegistrationEdit = (
  props: ITenantRegistrationCreateProps
) => {
  const notify = useNotification(props, "editSuccess");
  return (
    <Edit
      {...props}
      actions={<EditActions />}
      onSuccess={notify}
      title="resources.master-tenant-registrations.title.edit"
      mutationMode="pessimistic"
    >
      <TenantRegistrationForm edit />
    </Edit>
  );
};
